import React from 'react';
import { Flex } from 'rebass';

const VendingMachine = () => {
  return  <Flex/>;
};

export default VendingMachine;
